import { Box, Button, Grid } from '@mui/material'
import { useFormContext } from 'react-hook-form'

import { ControlledSelector, SplitButton } from 'components/common'
import { DriverTypeValues, ReportTypeButtonsId, ReportTypeButtonValues } from 'constants/index'

interface IProps {
  isProcessing: boolean
  onReportButtonClick: (buttonId: ReportTypeButtonsId) => void
  onClearAll: () => void
}

const FilterCriteriaForm = (props: IProps) => {
  const { isProcessing, onReportButtonClick, onClearAll } = props
  const { control } = useFormContext()

  return (
    <Grid container spacing={3}>
      <Grid item xs={2}>
        <ControlledSelector
          control={control}
          name='driverType'
          label='Driver Type'
          options={DriverTypeValues}
          displayEmpty
          emptyValue={{ value: null, label: 'All Driver Types' }}
        />
      </Grid>

      <Grid item xs={10}>
        <Grid container spacing={3} item justifyContent='flex-end'>
          <Grid item>
            <Box display='flex' justifyContent='center'>
              <Button variant='contained' color='grey' onClick={onClearAll}>
                Clear All
              </Button>
            </Box>
          </Grid>

          <Grid item>
            <SplitButton
              options={ReportTypeButtonValues}
              loading={isProcessing}
              onButtonClick={onReportButtonClick}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default FilterCriteriaForm
